<template>
  <div class="v3-user-board-wrap">
    <div class="v3-user-board">
      <div class="user-data d-flex align-items-center">
        <div class="v3-avatar">
          <img
            :src="user.avatar ? user.avatar : '/img/avatars/user-avatar.jpeg'"
            alt="user-avatar"
          />
        </div>
        <div class="v3-user-info ps-2 flex-1">
          <b class="font-size-14 text-wrap" data-test-id="sidebar-user-names">{{
            user.name
          }}</b>
          <p class="m-0 font-size-12">{{ user.role.name }}</p>
        </div>
      </div>
      <div>
        <SidebarSchools> </SidebarSchools>
      </div>
      <div class="user-actions d-flex align-items-center p-0">
        <div class="flex-1 text-center py-2">
          <router-link
            data-test-id="sidebar-user-box"
            class="d-block"
            to="/user-settings"
            ><i class="ri-settings-3-line"></i>
          </router-link>
        </div>
        <div class="flex-1 text-center d-flex justify-content-center py-2">
          <SoundBtn :user="user"></SoundBtn>
        </div>
        <div
          @click="logOut"
          data-test-id="sidebar-logout"
          class="flex-1 text-center py-2 v3-tooltip"
        >
          <span class="tooltiptext">Log Out</span>
          <i class="ri-logout-circle-r-line"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarSchools from "./SidebarSchools.vue"
import SoundBtn from "./SoundBtn.vue"
import { useStore } from "vuex"

export default {
  components: { SidebarSchools, SoundBtn },
  props: {
    user: Object
  },
  setup() {
    const store = useStore()

    const logOut = () => {
      store.dispatch("authentication/logOut")
    }
    return {
      logOut
    }
  }
}
</script>

<style></style>
